import * as React from "react";
import classnames from "classnames";
import { Util } from "@grandvisionhq/forms";
import { parseHtml } from "@grandvisionhq/lib-utils-html";
import { useIntl } from "@grandvisionhq/state";
import CheckboxField from "../../../CheckboxField/v3/components/ConsentsAndOptIns/CheckboxField/CheckboxField.js";
const labelOptions = { parseHTML: false, parseLink: true, openLinksInNewTab: true };
const ChildItems = ({
  items,
  errorMessage,
  className
}) => {
  const { getFormattedLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("ul", { className }, items?.map(({ title, value, ariaLabel }) => /* @__PURE__ */ React.createElement("li", { key: title, className: "consents-and-opt-ins__consent" }, /* @__PURE__ */ React.createElement(
    CheckboxField,
    {
      name: value,
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, parseHtml(getFormattedLabel(title, labelOptions))),
      "aria-label": ariaLabel,
      error: errorMessage,
      "data-t": value
    }
  ))));
};
const ConsentsAndOptIns = ({
  className,
  errorMessage,
  consents,
  optIns,
  showOptIns = true,
  showConsents = true,
  ...rest
}) => {
  const [state, setState] = React.useState({});
  const { getFormattedLabel } = useIntl();
  const handleChange = (fieldState) => {
    setState((prev) => ({
      ...prev,
      [fieldState.name]: fieldState.value === "true"
    }));
  };
  if (!showConsents && !showOptIns) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("ul", { ...rest, className: classnames("consents-and-opt-ins", className) }, showConsents && consents.map((consent) => /* @__PURE__ */ React.createElement("li", { key: consent.title, className: "consents-and-opt-ins__consent" }, /* @__PURE__ */ React.createElement(
    CheckboxField,
    {
      name: consent.value,
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, parseHtml(getFormattedLabel(consent.title, labelOptions)), /* @__PURE__ */ React.createElement("span", { className: "consents-and-opt-ins__required-asterisk" }, "*")),
      "aria-label": consent.ariaLabel,
      error: errorMessage,
      required: true,
      validations: [Util.validations.isRequired],
      "data-t": consent.value,
      onChange: (state2) => handleChange(state2)
    }
  ), consent.children ? /* @__PURE__ */ React.createElement(
    ChildItems,
    {
      className: classnames("consents-and-opt-ins__children", {
        "consents-and-opt-ins__children--active": state[consent.value]
      }),
      errorMessage,
      items: consent.children
    }
  ) : null)), showOptIns && optIns.map((optIn) => /* @__PURE__ */ React.createElement("li", { key: optIn.title, className: "consents-and-opt-ins__opt-in" }, /* @__PURE__ */ React.createElement(
    CheckboxField,
    {
      name: optIn.value,
      label: parseHtml(getFormattedLabel(optIn.title, labelOptions)),
      "aria-label": optIn.ariaLabel,
      error: "",
      required: false,
      "data-t": optIn.value,
      onChange: (state2) => handleChange(state2)
    }
  ), optIn.children ? /* @__PURE__ */ React.createElement(
    ChildItems,
    {
      className: classnames("consents-and-opt-ins__children", {
        "consents-and-opt-ins__children--active": state[optIn.value]
      }),
      errorMessage,
      items: optIn.children
    }
  ) : null)));
};
export {
  ConsentsAndOptIns as default
};
//# sourceMappingURL=ConsentsAndOptIns.js.map
